import { useAllowNewIceT } from './checkerTransmittal/checkerTransmittal.hooks';
import { useAllowNewDT } from './designerTransmittal/designerTransmittal.hooks';
import { useAllowNewLir } from './lambethInternalReview/lambethInternalReview.hooks';
import { useAllowNewST } from './siteTransmittal/siteTransmittal.hooks';
import { ETransmittalType } from './transmittal.constants';

export const useAllowNewTransmittal = (transmittalType?: ETransmittalType) => {
  const isAllowNewDT = useAllowNewDT();
  const isAllowNewST = useAllowNewST();
  const isAllowNewIceT = useAllowNewIceT();
  const isAllowNewLir = useAllowNewLir();

  if (transmittalType === ETransmittalType.DESIGNER) {
    return isAllowNewDT;
  }
  if (transmittalType === ETransmittalType.SITE) {
    return isAllowNewST;
  }
  if (transmittalType === ETransmittalType.ICE) {
    return isAllowNewIceT;
  }
  if (transmittalType === ETransmittalType.REVIEWER) {
    return isAllowNewLir;
  }
  return isAllowNewDT || isAllowNewST || isAllowNewIceT || isAllowNewLir;
};
